import stbApiGateway from '@/services/stbApiGateway';
import * as types from '../../../mutationTypes';

export const fetchExcursionTypes = async ({ state, commit }, { oauthSignature, clientSid }) => {
  const stbApi = stbApiGateway(state.axios);
  const response = await stbApi.getExcursionTypes(oauthSignature, clientSid);
  if (response.excursionTypes) {
    commit(types.SET_EXCURSION_TYPES, response.excursionTypes);
  }
  return response;
};
